import $api from "@/frontend/shared/api/axios";

export async function postPortfolioCompaniesBulk({
  portfolioCompanyIds,
  doneProcessingCompanyIds
}: {
  portfolioCompanyIds: number[];
  doneProcessingCompanyIds: number[];
}) {
  const response = await $api.post("/portfolio-companies/bulk", {
    portfolioCompanyIds,
    onlyStatus: doneProcessingCompanyIds.length === 0
  });

  return response.data.data;
}
